export const CONSTRAINTS = {
    METADATA_KEY: 'fineco:fineco_portfolio_constraints',
    MODE_KEY: 'fineco:constraints_mode',
    PORTFOLIO_PRODUCT_VALUES_KEY: 'fineco:portfolio_product_values',
    IMPORTED_PORTFOLIO_KEY: 'fineco:fineco_imported_portfolio',
    // Tracks which saved profile the thread is currently associated with so the
    // Vincoli dropdown can restore the right selection after a page refresh.
    // Payload: { id: string, name: string } when a profile is applied, or null
    // when the thread is on predefiniti / unsaved edits.
    APPLIED_PROFILE_KEY: 'fineco:applied_constraint_profile',
    SUBMIT_MESSAGE: 'Sono stati impostati dei vincoli. Crea un nuovo portafoglio adesso.',
    SUBMIT_MESSAGE_REBALANCING: 'Sono stati impostati dei vincoli. Ribilancia il portafoglio adesso.',
    // Text on the hidden assistant message that carries Reset / applyProfile /
    // applyPredefiniti silent-sync metadata. The message is filtered out of
    // the visible transcript (hidden: true), but the agent sees it in its
    // history — without a note, a sudden constraints diff with no preceding
    // user turn is unexplainable. The text tells the agent the change came
    // from the user (not from a tool the agent itself ran) and that no
    // action is requested.
    SILENT_SYNC_MESSAGE: 'L\'utente ha aggiornato i vincoli. Nessuna richiesta da elaborare.',
    TOAST: {
        TITLE_KEY: 'ws_actions.titleConstraints',
        DESCRIPTION_KEY: 'ws_actions.toastConstraints'
    },
    BUSY_OVERLAY: {
        TITLE_KEY: 'ws_actions.titleAgentBusy',
        DESCRIPTION_KEY: 'ws_actions.agentBusy'
    }
} as const;
